<div
    [class]="(currentMemberListViewLocation() === MemberListViewLocations.MemberListPage) ? 'main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3' : ''">
    @if (currentMemberListViewLocation() === MemberListViewLocations.MemberListPage) {
        <ms-page-title />
    }

    <!-- Page Header -->
    <div class="page-title-wrapper">
        <div class="d-flex justify-content-between flex-row flex-wrap gap-3">
            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Members" aria-label="Search Members"
                        [ngModel]="userSessionService.membersFilter.searchTerm"
                        (ngModelChange)="userSessionService.membersFilter.searchTerm = $event"
                        (keyup.enter)="loadMembers(false)" aria-describedby="search-description">

                    @if (userSessionService.membersFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button" (click)="loadMembers(false)"
                            id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by name or email address
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-member-search-filter
                    [hidden]="currentMemberListViewLocation() !== MemberListViewLocations.MemberListPage"
                    (filterApplied)="filterApplied()"></ms-member-search-filter>

                @if (currentMemberListViewLocation() === MemberListViewLocations.MemberListPage) {
                <ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
                    (selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <span>List Actions</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item" (click)="onAddMemberClicked()">
                                <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add Member
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Activate)">
                                <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />Activate
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Deactivate)">
                                <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate
                            </a>
                        </li>
                        <!-- DEV-2464: hidden for MMP - restore Suspend / Unsuspend when ready
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Suspend)">
                                <fa-duotone-icon icon="pause" secondaryOpacity="0.9" class="me-2" />Suspend
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Unsuspend)">
                                <fa-duotone-icon icon="play" secondaryOpacity="0.9" class="me-2" />Unsuspend
                            </a>
                        </li>
                        -->
                        <li>
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Delete)">
                                <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
                            </a>
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [MemberPermission.Update],
                            userPermissionOnly: false
                        }">
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Invite)">
                                <fa-duotone-icon icon="message" secondaryOpacity="0.9" class="me-2" />Invite
                            </a>
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [MemberPermission.Update],
                            userPermissionOnly: false
                        }">
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="confirmBulkAction(MemberBulkActions.Uninvite)">
                                <fa-duotone-icon icon="message-slash" secondaryOpacity="0.9" class="me-2" />Uninvite
                            </a>
                        </li>
                    </ul>
                </div>
                }

                @if (currentMemberListViewLocation() === MemberListViewLocations.PropertyProfilePage && !isParentEntityDeleted()) {
                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#addMembersToPropertyModal">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="d-none d-sm-inline" />
                    Attach Members
                </button>
                }

                @if (currentMemberListViewLocation() === MemberListViewLocations.AddMemberToPropertyModal) {
                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"
                        [class.placeholder]="isLoading">
                        Add Members
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item" (click)="onAddMembersToProperty(PropertyMemberTypes.Owner)">
                                <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add as Owner</a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="onAddMembersToProperty(PropertyMemberTypes.Tenant)">
                                <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add as Tenant</a>
                        </li>
                    </ul>
                </div>
                }
            </div>
        </div>
    </div>

    <div>
        <div class="d-flex flex-wrap">
            <div class="mb-0 text-start flex-grow-0 w-50" #jumpToElementMobile>
                Showing: {{memberList().length}} of {{totalCount | number}}
                <div class="badge bg-primary ms-0 ms-sm-2"
                    [hidden]="currentMemberListViewLocation() === MemberListViewLocations.PropertyProfilePage 
                    || currentMemberListViewLocation() === MemberListViewLocations.TransferOrganizationOwnershipModal
                    || currentMemberListViewLocation() === MemberListViewLocations.ManageOrganizationAdminsModal">
                    Selected: {{selectedCount() | number}} </div>
            </div>
            <div class="flex-grow-1 text-end d-block d-sm-none">
                <button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start"
                    [hidden]="currentMemberListViewLocation() === MemberListViewLocations.PropertyProfilePage
                    || currentMemberListViewLocation() === MemberListViewLocations.TransferOrganizationOwnershipModal
                    || currentMemberListViewLocation() === MemberListViewLocations.ManageOrganizationAdminsModal"
                    (click)="toggleSelectAll()">
                    <fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
                    <fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
                    {{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
                </button>
            </div>
        </div>

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table class="table table-hover fixed-header placeholder-glow" msResponsiveTable>
                <thead #jumpToElement>
                    <tr>
                        <th scope="col" msResponsiveTableColumn="checkbox" [priority]="1"><input id="toggleAllSelection" name="toggleAllSelection" type="checkbox"
                                class="form-check-input fs-6" [checked]="isSelectAll" (change)="toggleSelectAll()"
                                [hidden]="currentMemberListViewLocation() !== MemberListViewLocations.MemberListPage" />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="name" [priority]="1" (click)="toggleSortDirection('Name')">
                            Name
                            <fa-duotone-icon icon="sort" class="ms-1 d-none d-xl-inline" size="lg"
                                [primaryOpacity]="(orderBy == memberListSortOptions.NameASC || orderBy == memberListSortOptions.EmailASC) ? '0.9' : '0.3' "
                                [secondaryOpacity]="(orderBy == memberListSortOptions.NameDESC || orderBy == memberListSortOptions.EmailDESC) ? '0.9' : '0.3' " />
                            <fa-duotone-icon icon="sort" class="ms-1 d-xl-none" size="lg"
                                [primaryOpacity]="(orderBy == memberListSortOptions.NameASC || orderBy == memberListSortOptions.EmailASC) ? '0.9' : '0.3' "
                                [secondaryOpacity]="(orderBy == memberListSortOptions.NameDESC || orderBy == memberListSortOptions.EmailDESC) ? '0.9' : '0.3' " />
                        </th>
                        <th scope="col" class="sortable" msResponsiveTableColumn="phone" [priority]="5" (click)="toggleSortDirection('Phone Number')">
                            Phone Number
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == memberListSortOptions.PhoneNumberASC ? '0.9' : '0.3'"
                                [secondaryOpacity]="orderBy == memberListSortOptions.PhoneNumberDESC? '0.9' : '0.3'" />
                        </th>
                        @if (currentMemberListViewLocation() !== MemberListViewLocations.TransferOrganizationOwnershipModal &&
                            currentMemberListViewLocation() !== MemberListViewLocations.ManageOrganizationAdminsModal) {
                            <th scope="col" class="sortable" msResponsiveTableColumn="role" [priority]="4" (click)="toggleSortDirection('Role')">
                                Role
                                <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                    [primaryOpacity]="orderBy == memberListSortOptions.MostPermissiveRoleASC ? '0.9' : '0.3'"
                                    [secondaryOpacity]="orderBy == memberListSortOptions.MostPermissiveRoleDESC ? '0.9' : '0.3'" />
                            </th>
                        }
                        @if (currentMemberListViewLocation() !== MemberListViewLocations.TransferOrganizationOwnershipModal &&
                            currentMemberListViewLocation() !== MemberListViewLocations.ManageOrganizationAdminsModal) {
                            <th scope="col" class="sortable" msResponsiveTableColumn="status" [priority]="2" (click)="toggleSortDirection('Status')">
                                Status
                                <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == memberListSortOptions.StatusASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == memberListSortOptions.StatusDESC ? '0.9' : '0.3' " />
                            </th>
                        }
                        @if (currentMemberListViewLocation() !== MemberListViewLocations.AddMemberToPropertyModal) {
                            <th scope="col" class="sortable" msResponsiveTableColumn="lastLogin" [priority]="6"
                                (click)="toggleSortDirection('Last Login')">
                                Last Login
                                <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                    [primaryOpacity]="orderBy == memberListSortOptions.LastLoginASC ? '0.9' : '0.3' "
                                    [secondaryOpacity]="orderBy == memberListSortOptions.LastLoginDESC ? '0.9' : '0.3' " />
                            </th>
                        }
                        @if (currentMemberListViewLocation() !== MemberListViewLocations.AddMemberToPropertyModal) {
                            <th class="fixed-header" scope="col" msResponsiveTableColumn="actions" [priority]="1">Actions</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    <!-- Table Row Start -->
                    @for (member of displayMembers; let i= $index; track member.memberId) {
                    <tr app-member-list-table-row class="align-middle" [className]="(i % 2 === 0)? 'even' : 'odd'">
                        <td msResponsiveTableColumn="checkbox" [priority]="1">
                            <input id="toggleAllSelection" type="checkbox" #toggleAllSelection class="form-check-input"
                                [value]="member.memberId"
                                [checked]="selectionItems() | itemSelection: member.memberId: isSelectAll"
                                (click)="selectionClicked({id: member.memberId, checked: toggleAllSelection.checked})"
                                [hidden]="currentMemberListViewLocation() === MemberListViewLocations.PropertyProfilePage ||
                                currentMemberListViewLocation() === MemberListViewLocations.TransferOrganizationOwnershipModal ||
                                currentMemberListViewLocation() === MemberListViewLocations.ManageOrganizationAdminsModal" />
                        </td>
                        <td msResponsiveTableColumn="name" [priority]="1">
                            <div class="d-flex align-items-center">
                                <ms-avatar [identity]="member" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
                                    [avatarAdditionalAttributes]="avatarAdditionalAttributes"
                                    [isLoading]="isLoading"></ms-avatar>

                                <div class="min-w-0 ms-3">
                                    <div class="fw-bold text-truncate" [class.placeholder]="isLoading"
                                        [msTooltip]="((member?.firstName ?? '') + ' ' + (member?.lastName ?? '')).trim()" msTooltipOnlyIfTruncated>
                                        {{member?.firstName + ' ' + member?.lastName}}
                                    </div>
                                    <small class="d-none d-sm-block text-truncate placeholder"
                                        [class.placeholder]="isLoading"
                                        [msTooltip]="member?.emailAddress ?? ''" msTooltipOnlyIfTruncated>{{member?.emailAddress}}</small>
                                </div>
                            </div>
                        </td>

                        <td msResponsiveTableColumn="phone" [priority]="5"><span [class.placeholder]="isLoading">{{member?.phoneNumber |
                                NANPFormattedPhone | noValue }}</span></td>

                        @if (currentMemberListViewLocation() !== MemberListViewLocations.TransferOrganizationOwnershipModal &&
                            currentMemberListViewLocation() !== MemberListViewLocations.ManageOrganizationAdminsModal) {
                            <td msResponsiveTableColumn="role" [priority]="4"><span [class.placeholder]="isLoading">{{member?.mostPermissiveRole | noValue}}</span>
                            </td>
                            <td msResponsiveTableColumn="status" [priority]="2">
                                <ms-status-badge [status]="member.status" [(isLoading)]="isLoading"></ms-status-badge>
                            </td>
                        }
                        @if (currentMemberListViewLocation() !== MemberListViewLocations.AddMemberToPropertyModal) {
                        <td class="pe-3" msResponsiveTableColumn="lastLogin" [priority]="6">
                            @if (member?.lastLogin) {
                            <span [class.placeholder]="isLoading">{{member?.lastLogin |
                                orgDate:'MMM dd, yyyy h:mm a' }}</span>
                            } @else {
                            <span [class.placeholder]="isLoading">{{ 'Never' }}</span>
                            }
                        </td>
                        }
                        @if (currentMemberListViewLocation() !== MemberListViewLocations.AddMemberToPropertyModal) {
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            @if (currentMemberListViewLocation() ===
                            MemberListViewLocations.TransferOrganizationOwnershipModal) {
                            @if (isAssignOwnerFlow()) {
                            <button class="btn btn-primary" [class.placeholder]="isLoading"
                                (click)="selectMemberForOwnershipTransfer(member)">
                                <fa-duotone-icon icon="user-plus" secondaryOpacity="0.9" class="me-2" />
                                Assign as Owner
                            </button>
                            } @else {
                            <button class="btn btn-ms-secondary" [class.placeholder]="isLoading"
                                (click)="selectMemberForOwnershipTransfer(member)">
                                <fa-duotone-icon icon="exchange" secondaryOpacity="0.9" class="me-2" />
                                Transfer to {{member.firstName}}
                            </button>
                            }
                            } @else if (currentMemberListViewLocation() ===
                            MemberListViewLocations.ManageOrganizationAdminsModal) {
                            <button class="btn btn-primary" [class.placeholder]="isLoading"
                                (click)="selectMemberForOwnershipTransfer(member)">
                                <fa-duotone-icon icon="user-plus" secondaryOpacity="0.9" class="me-2" />
                                Assign Admin
                            </button>
                            } @else {
                            <div class="dropdown">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
                                    (click)="onActionsDropdownOpened(member)" [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><a class="dropdown-item" [routerLink]="['/members/profile/', member.memberId]">
                                            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View</a>
                                    </li>
                                    @if (currentMemberListViewLocation() ===
                                    MemberListViewLocations.PropertyProfilePage) {
                                    <li>
                                        <a class="dropdown-item" (click)="detachMemberFromProperty(member)">
                                            <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="me-2" />Detach
                                            from Property
                                        </a>
                                    </li>
                                    }
                                    @if (currentMemberListViewLocation() !== MemberListViewLocations.PropertyProfilePage) {
                                    @if (member?.status === MemberStatuses.Deactivated) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [MemberPermission.Status],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item" [class.disabled]="isCheckingProtection(member) || isProtectedFromModification(member)"
                                            [attr.aria-disabled]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? 'true' : null"
                                            [attr.tabindex]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? -1 : null"
                                            (click)="(isCheckingProtection(member) || isProtectedFromModification(member)) ? $event.stopPropagation() : confirmMemberStatusUpdate(MemberStatusActions.Activate, member)">
                                            @if (isCheckingProtection(member)) {
                                            <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                                            } @else {
                                            <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />
                                            }Activate
                                        </a>
                                    </li>
                                    }
                                    @else if (member?.status === MemberStatuses.Active && (!isOwnAccount(member) || canDeactivateOwnAccount())) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [MemberPermission.Status],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item" [class.disabled]="isCheckingProtection(member) || isProtectedFromModification(member)"
                                            [attr.aria-disabled]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? 'true' : null"
                                            [attr.tabindex]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? -1 : null"
                                            (click)="(isCheckingProtection(member) || isProtectedFromModification(member)) ? $event.stopPropagation() : confirmMemberStatusUpdate(MemberStatusActions.Deactivate, member)">
                                            @if (isCheckingProtection(member)) {
                                            <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                                            } @else {
                                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />
                                            }Deactivate
                                        </a>
                                    </li>
                                    <!-- DEV-2464: hidden for MMP - restore Suspend when ready
                                    <li>
                                        <a class="dropdown-item" (click)="confirmMemberStatusUpdate(MemberStatusActions.Suspend, member)">
                                            <fa-duotone-icon icon="pause" secondaryOpacity="0.9" class="me-2" />Suspend
                                        </a>
                                    </li>
                                    -->
                                    }
                                    @if (member?.status === MemberStatuses.Created || member?.status === MemberStatuses.Expired) {
                                    <li>
                                        <a class="dropdown-item" (click)="confirmMemberInvite(member)">
                                            <fa-duotone-icon icon="message" secondaryOpacity="0.9" class="me-2" />Invite
                                        </a>
                                    </li>
                                    }
                                    @if (member?.status === MemberStatuses.Invited) {
                                    <li>
                                        <a class="dropdown-item" (click)="confirmMemberUninvite(member)">
                                            <fa-duotone-icon icon="message-slash" secondaryOpacity="0.9" class="me-2" />Uninvite
                                        </a>
                                    </li>
                                    }
                                    <!-- DEV-2464: hidden for MMP - restore Suspended-state actions (Deactivate / Unsuspend) when ready
                                    @else if (member?.status === MemberStatuses.Suspended) {
                                    <li>
                                        <a class="dropdown-item" (click)="confirmMemberStatusUpdate(MemberStatusActions.Deactivate, member)">
                                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" (click)="confirmMemberStatusUpdate(MemberStatusActions.Unsuspend, member)">
                                            <fa-duotone-icon icon="play" secondaryOpacity="0.9" class="me-2" />Unsuspend
                                        </a>
                                    </li>
                                    }
                                    -->
                                    @if (member?.status !== MemberStatuses.Deleted && (!isOwnAccount(member) || canDeleteOwnAccount())) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [MemberPermission.Delete],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item" [class.disabled]="isCheckingProtection(member) || isProtectedFromModification(member)"
                                            [attr.aria-disabled]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? 'true' : null"
                                            [attr.tabindex]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? -1 : null"
                                            (click)="(isCheckingProtection(member) || isProtectedFromModification(member)) ? $event.stopPropagation() : confirmMemberDeletion(member)">
                                            @if (isCheckingProtection(member)) {
                                            <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                                            } @else {
                                            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />
                                            }Delete
                                        </a>
                                    </li>
                                    }
                                    }
                                </ul>
                                </div>
                            }
                        </td>
                        }
                    </tr>
                    }
                    <!-- Table Row End -->
                </tbody>
                <tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
                    [hasNext]="hasNext" [itemCount]="displayMembers.length" (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (member of displayMembers; let i= $index; track member.memberId) {
            <div class="card d-flex pt-1 d-inline d-sm-none my-3">

                <div class="d-flex flex-column card-body">

                    <div class="d-flex flex-row">
                        <div class="card-left-column d-block-flex text-center">
                            @if (currentMemberListViewLocation() === MemberListViewLocations.TransferOrganizationOwnershipModal
                            || currentMemberListViewLocation() === MemberListViewLocations.ManageOrganizationAdminsModal) {
                            <ms-avatar [identity]="member" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
                                [avatarAdditionalAttributes]="avatarAdditionalAttributes" [isLoading]="isLoading"></ms-avatar>
                            } @else {
                            <ms-avatar [identity]="member" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
                                [isSelected]="selectionItems() | itemSelection: member.memberId : isSelectAll"
                                [avatarAdditionalAttributes]="avatarAdditionalAttributes" [isLoading]="isLoading"
                                (clicked)="selectionClicked($event)"></ms-avatar>

                            <ms-status-badge class="mt-3" [status]="member.status" [(isLoading)]="isLoading"></ms-status-badge>
                            }
                        </div>

                        <div class="right-card-column w-100">
                            <h5 class="card-title mb-0" [class.placeholder]="isLoading">{{member.firstName + ' ' +
                                member.lastName}}</h5>
                            <div class="fw-semibold" [class.placeholder]="isLoading">{{member.emailAddress}}
                            </div>
                            <div class="card-text" [class.placeholder]="isLoading">{{member.phoneNumber | NANPFormattedPhone }}</div>
                            <div class="card-text" [class.placeholder]="isLoading">Last Login:
                                {{member.lastLogin | orgDate:'shortDate'}}</div>
                            <div class="card-text" [class.placeholder]="isLoading">{{member.mostPermissiveRole}}</div>
                        </div>
                    </div>
                </div>

                @if (currentMemberListViewLocation() === MemberListViewLocations.TransferOrganizationOwnershipModal) {
                @if (isAssignOwnerFlow()) {
                <button class="mobile-action-button" [class.placeholder]="isLoading"
                    (click)="selectMemberForOwnershipTransfer(member)">
                    <fa-duotone-icon icon="user-plus" secondaryOpacity="0.9" class="me-2" />
                    Assign as Owner
                </button>
                } @else {
                <button class="mobile-action-button" [class.placeholder]="isLoading"
                    (click)="selectMemberForOwnershipTransfer(member)">
                    <fa-duotone-icon icon="exchange" secondaryOpacity="0.9" class="me-2" />
                    Transfer to {{member.firstName}}
                </button>
                }
                } @else if (currentMemberListViewLocation() === MemberListViewLocations.ManageOrganizationAdminsModal) {
<button class="mobile-action-button" [class.placeholder]="isLoading" [disabled]="isLoading"
                    (click)="!isLoading && selectMemberForOwnershipTransfer(member)">
                    <fa-duotone-icon icon="user-plus" secondaryOpacity="0.4" class="me-2" />
                    Assign Admin
                </button>
                } @else {
                <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                    (click)="onActionsDropdownOpened(member)" [class.placeholder]="isLoading">
                    Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end w-75">
                    <li><a class="dropdown-item" [routerLink]="['/members/profile/', member.memberId]">
                            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View</a>
                    </li>
                    @if (currentMemberListViewLocation() === MemberListViewLocations.PropertyProfilePage) {
                    <li>
                        <a class="dropdown-item" (click)="detachMemberFromProperty(member)">
                            <fa-duotone-icon icon="minus" secondaryOpacity="0.9" class="me-2" />Detach from Property
                        </a>
                    </li>
                    }
                    @if (currentMemberListViewLocation() !== MemberListViewLocations.PropertyProfilePage) {
                    @if (member?.status === MemberStatuses.Deactivated) {
                    <li *ifHasPermission="{
                        requiredPermissions: [MemberPermission.Status],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item" [class.disabled]="isCheckingProtection(member) || isProtectedFromModification(member)"
                            [attr.aria-disabled]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? 'true' : null"
                            [attr.tabindex]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? -1 : null"
                            (click)="(isCheckingProtection(member) || isProtectedFromModification(member)) ? $event.stopPropagation() : confirmMemberStatusUpdate(MemberStatusActions.Activate, member)">
                            @if (isCheckingProtection(member)) {
                            <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                            } @else {
                            <fa-duotone-icon icon="power-off" secondaryOpacity="0.9" class="me-2" />
                            }Activate
                        </a>
                    </li>
                    }
                    @else if (member?.status === MemberStatuses.Active && (!isOwnAccount(member) || canDeactivateOwnAccount())) {
                    <li *ifHasPermission="{
                        requiredPermissions: [MemberPermission.Status],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item" [class.disabled]="isCheckingProtection(member) || isProtectedFromModification(member)"
                            [attr.aria-disabled]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? 'true' : null"
                            [attr.tabindex]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? -1 : null"
                            (click)="(isCheckingProtection(member) || isProtectedFromModification(member)) ? $event.stopPropagation() : confirmMemberStatusUpdate(MemberStatusActions.Deactivate, member)">
                            @if (isCheckingProtection(member)) {
                            <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                            } @else {
                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />
                            }Deactivate
                        </a>
                    </li>
                    <!-- DEV-2464: hidden for MMP - restore Suspend when ready
                    <li>
                        <a class="dropdown-item"
                            (click)="confirmMemberStatusUpdate(MemberStatusActions.Suspend, member)">
                            <fa-duotone-icon icon="pause" secondaryOpacity="0.9" class="me-2" />Suspend
                        </a>
                    </li>
                    -->
                    }
                    @if (member?.status === MemberStatuses.Created || member?.status === MemberStatuses.Expired) {
                    <li>
                        <a class="dropdown-item" (click)="confirmMemberInvite(member)">
                            <fa-duotone-icon icon="message" secondaryOpacity="0.9" class="me-2" />Invite
                        </a>
                    </li>
                    }
                    @if (member?.status === MemberStatuses.Invited) {
                    <li>
                        <a class="dropdown-item" (click)="confirmMemberUninvite(member)">
                            <fa-duotone-icon icon="message-slash" secondaryOpacity="0.9" class="me-2" />Uninvite
                        </a>
                    </li>
                    }
                    <!-- DEV-2464: hidden for MMP - restore Suspended-state actions (Deactivate / Unsuspend) when ready
                    @else if (member?.status === MemberStatuses.Suspended) {
                    <li>
                        <a class="dropdown-item"
                            (click)="confirmMemberStatusUpdate(MemberStatusActions.Deactivate, member)">
                            <fa-duotone-icon icon="ban" secondaryOpacity="0.9" class="me-2" />Deactivate
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item"
                            (click)="confirmMemberStatusUpdate(MemberStatusActions.Unsuspend, member)">
                            <fa-duotone-icon icon="play" secondaryOpacity="0.9" class="me-2" />Unsuspend
                        </a>
                    </li>
                    }
                    -->
                    @if (member?.status !== MemberStatuses.Deleted && (!isOwnAccount(member) || canDeleteOwnAccount())) {
                    <li *ifHasPermission="{
                        requiredPermissions: [MemberPermission.Delete],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item" [class.disabled]="isCheckingProtection(member) || isProtectedFromModification(member)"
                            [attr.aria-disabled]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? 'true' : null"
                            [attr.tabindex]="(isCheckingProtection(member) || isProtectedFromModification(member)) ? -1 : null"
                            (click)="(isCheckingProtection(member) || isProtectedFromModification(member)) ? $event.stopPropagation() : confirmMemberDeletion(member)">
                            @if (isCheckingProtection(member)) {
                            <div class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Loading...</span></div>
                            } @else {
                            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />
                            }Delete
                        </a>
                    </li>
                    }
                    }
                </ul>
                }

            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayMembers.length" (jumpToClicked)="jumpToTop($event)">
            </div>

        </div>

        <ms-confirmation-modal #memberListConfirmationModalRef modalId="memberListConfirmationModal"
            [enableNotes]="false" [isNoteRequired]="false" confirmButtonText="Yes" cancelButtonText="No"
            [(isSubmitting)]="isSubmitting"
            (confirmed)="confirmationConfirmFunction($event)" (cancelled)="confirmationCancelFunction()" />

        <ms-info-modal #memberListInfoModalRef modalId="memberListInfoModal" />

        <ms-member-form-modal [organization]="userSessionService.activeOrganization()"
            (onSuccessConfirm)="loadMembers()" />
    </div>
</div>
